package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("food_and_health")
@Composable
fun KidsFoodAndHealthPage() {
    BlogLayout(
        PageProperties(
            "Food",
            ""
        ),
        BlogProperties("Kids", "Food And Health")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "New Words",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Nutrients",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "vitamins",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "carbohydrates",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "coal",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Kerosene stove",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Word Galaxy",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Obsese: Weighing more than what is healthy.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stale: Old and not fresh any more.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Oozing: To flower leak out slowly.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Explain the following terms.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Junk food ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Food that contain a lot of fat and sugar & has very little nutritional value is known as junk food.",
                        modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Balanced diet ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "A diet that contain all the nutrients in the right amounts required for good heath that is called balanced diet.",
                        modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Digestive system ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "The organ system that help us to digest food is call the digestive system.",
                        modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Community eating ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "When a large number of people eat together at a place the event is known as community eating.",
                        modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Write minerals present in milk.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Calcium, Phosphorus, Potassium, Magnesium, Zinc, Iodine and Sodium",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Name a plant root which can be eaten as a vegetable.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Carrot and beetroots is eaten as a vegetable.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is nutrients?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The substance or components present in food that provide us with energy are called nutrients.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Mention two sources of dietary fibres.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Beans and whole grains are too source of dietary fibres.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is balanced diet?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "A diet that contain all the nutrients in the right amounts required for good heath that is called balanced diet.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }
            }
        }
    }
}















